export const str2json = function (str, notevil) {
  try {
    if (notevil) {
      return JSON.parse(
        str
          // wrap keys without quote with valid double quote
          .replace(/([\$\w]+)\s*:/g, (_, $1) => {
            return `"${$1}":`;
          })
          // replacing single quote wrapped ones to double quote
          .replace(/'([^']+)'/g, (_, $1) => {
            return `"${$1}"`;
          })
      );
    } else {
      return new Function('', `var json = ${str}; return JSON.parse(JSON.stringify(json));`)();
    }
  } catch (e) {
    return false;
  }
};

export const slugify = (text) => {
  return text
    .toString() // Cast to string
    .toLowerCase() // Convert the string to lowercase letters
    .normalize('NFD') // The normalize() method returns the Unicode Normalization Form of a given string.
    .trim() // Remove whitespace from both sides of a string
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w\-]+/g, '') // Remove all non-word chars
    .replace(/\-\-+/g, '-'); // Replace multiple - with single -
};
